import classNames from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';
import * as React from 'react';
import ReactTextareaAutosize from 'react-textarea-autosize';
import InputError from '../Input/InputError';
import styles from './style.m.less';

type Props = ComponentPropsWithoutRef<typeof ReactTextareaAutosize> & { error?: string | null };

function TextareaAutosize({ error, className, ...otherProps }: Props, ref: React.Ref<HTMLTextAreaElement>) {
    return (
        <>
            <ReactTextareaAutosize
                {...otherProps}
                className={classNames([
                    styles.textareaAutosize,
                    className,
                    {
                        [styles.invalid]: !!error,
                    },
                ])}
                ref={ref}
            />
            <InputError error={error} />
        </>
    );
}

export default React.forwardRef(TextareaAutosize);
